import type {
  ExternalSitePageRule,
  ExternalSiteRule,
  IExternalSiteManager,
} from "./types";

export const createExternalSitesManager = () => {
  const sites: ExternalSiteRule[] = [];

  const result: IExternalSiteManager = {
    getSiteInfo: async (args) => {
      const infos = await Promise.all(
        sites.map(async (site) => {
          const info = await site.getInfo(args);
          if (info !== "INVALID") {
            return info;
          }
        })
      );

      return infos.find((site) => site) || { siteInfo: {}, url: "" };
    },

    getSiteByValue: (value) => {
      const [siteType] = value.split(":");
      const site = sites.find((site) => site.type === siteType);
      return site;
    },

    getPageRule: (targetValue) => {
      let result: ExternalSitePageRule | undefined;
      sites.some((site) => {
        return site.pageRules.some((pageRule) => {
          if (pageRule.targetValue === targetValue) {
            result = pageRule;
            return true;
          }
          return false;
        });
      });

      return result;
    },

    getPageRules: (siteType) => {
      const site = sites.find((site) => site.type === siteType);
      if (!site) {
        return [];
      }
      return site.pageRules;
    },

    register: (site) => {
      sites.push(site);
    },
  };

  return result;
};
